'use client';

import type { MenuQuickLink, PrimaryNavigationItem } from '../../types';
import { DesktopMenu } from './desktop-menu';
import { MobileMenu } from './mobile-menu';

import './menu.scss';

type MenuProps = {
    items: PrimaryNavigationItem[];
    quickLinks: MenuQuickLink[];
};

export function Menu({ items, quickLinks }: MenuProps) {
    return (
        <div className="menu">
            <div className="menu__desktop">
                <DesktopMenu items={items} />
            </div>
            <div className="menu__mobile">
                <MobileMenu items={items} quickLinks={quickLinks} />
            </div>
        </div>
    );
}
